import {useAttendeeVariables} from 'Event'
import PasswordFieldConfig from 'Event/Step1/SetPasswordForm/PasswordField/PasswordFieldConfig'
import {useTemplate} from 'Event/TemplateProvider'
import TextField from 'Event/auth/TextField'
import Configurable from 'organization/Event/Configurable'
import React from 'react'
import {UseFormMethods} from 'react-hook-form'

export default function ConfirmPasswordField(
  props: Pick<UseFormMethods, 'register' | 'watch'> & {
    error?: string
    disabled?: boolean
  },
) {
  const {error, disabled, register, watch} = props
  const v = useAttendeeVariables()
  const {setPasswordForm} = useTemplate()

  const password = watch('password')

  return (
    <Configurable>
      <PasswordFieldConfig />
      <TextField
        label={v(setPasswordForm.confirmPasswordLabel)}
        type="password"
        fullWidth
        name="password_confirmation"
        variant="outlined"
        inputProps={{
          ref: register({
            required: 'Confirm Password is required',
            validate: (value: any) =>
              value === password || 'Passwords are not a match',
          }),
          'aria-label': 'confirm password input',
        }}
        error={Boolean(error)}
        helperText={error}
        disabled={disabled}
        {...setPasswordForm.input}
      />
    </Configurable>
  )
}
